<ng-template #template>
  <div class="col-12" [hidden]="hidden">
    <div class="card" style="background-color: #0e0e29">
      <div class="card-body">
        <h3 style="color: white">{{ model?.isoRoceTitle }}</h3>
        <div style="display: block">
          <canvas
            baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [colors]="lineChartColors"
            [legend]="lineChartLegend"
            [plugins]="chartPlugins"
            [chartType]="lineChartType"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
